import React from 'react';

/**
 * Camada decorativa de fundo para o hero versão B.
 * Absolute, atrás do conteúdo, pointer-events-none, aria-hidden.
 * Usa emoji em tons pastéis, sutil o suficiente para não atrapalhar leitura.
 */
export function HeroDecorations() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      {/* Estrela topo-esquerda */}
      <span className="absolute left-[6%] top-[8%] text-2xl opacity-20">⭐</span>

      {/* Coração superior-central */}
      <span className="absolute left-[35%] top-[5%] text-xl opacity-15">💗</span>

      {/* Sol canto superior-direito */}
      <span
        className="absolute right-[5%] top-[4%] text-3xl opacity-15"
        style={{ transform: 'rotate(15deg)' }}
      >
        ☀️
      </span>

      {/* Faísca superior-direito secundária */}
      <span className="absolute right-[18%] top-[12%] text-lg opacity-20">✨</span>

      {/* Aviãozinho no meio-direito */}
      <span
        className="absolute right-[10%] top-[38%] text-2xl opacity-15"
        style={{ transform: 'rotate(-12deg)' }}
      >
        ✈️
      </span>

      {/* Estrela pequena lado esquerdo-meio */}
      <span className="absolute left-[3%] top-[45%] text-base opacity-15">⭐</span>

      {/* Coração inferior-esquerdo */}
      <span className="absolute bottom-[12%] left-[12%] text-xl opacity-15">💗</span>

      {/* Faísca inferior-central */}
      <span className="absolute bottom-[8%] left-[50%] text-lg opacity-20">✨</span>

      {/* Sol pequeno inferior-direito */}
      <span
        className="absolute bottom-[5%] right-[8%] text-xl opacity-10"
        style={{ transform: 'rotate(-10deg)' }}
      >
        ☀️
      </span>

      {/* Trilha pontilhada SVG — diagonal sutil */}
      <svg
        className="absolute inset-0 h-full w-full opacity-[0.06]"
        viewBox="0 0 800 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M 20 180 Q 200 120 400 100 Q 600 80 780 20"
          stroke="var(--color-secondary)"
          strokeWidth="3"
          strokeDasharray="8 8"
          strokeLinecap="round"
        />
        <path
          d="M 0 100 Q 180 60 360 50 Q 540 40 780 10"
          stroke="var(--color-third)"
          strokeWidth="2"
          strokeDasharray="6 10"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
